<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>

        <BaseInput
          class="search-input full"
          style="width: 200px;"
          v-model="search"
          @focus="search_focused = true"
          @blur="search_focused = false"
          :placeholder="$t('tables.search')"
          :readonly="false"
        />

        <BaseButton class="ml-8 nowrap"
          variant="secondary"
          icon="refresh-cw"
          size="md"
          v-if="currentPosSystem"
          @click="$router.push('/pos_integrations/'+currentPosSystem)">
          {{ $t("halls_tables.pos_sync") }}
        </BaseButton>

        <BaseButton
          color="green-5"
          size="md"
          icon="user-plus"
          class="ml-8 nowrap"
          variant="primary"
          @click="createWaiter"
        >
          {{ $t("workers_table.add_button") }}
        </BaseButton>

      </template>
    </Header>

    <IQOSTable
      :cols="[
        {
          title: '№',
          width: 80,
          index: true,
        },
        {
          key: 'name',
          title: $t('workers_table.col_name'),
        },
        {
          title: $t('workers_table.col_pin'),
          key: 'pin',
          width: 80,
        },
        {
          title: $t('worker_profile.phone_ph'),
          key: 'phone',
        },
        {
          title: 'QRWaiter Bot',
          key: 'bot',
          width: 160,
        },
      ]"
      :hasActions="true"
      :rows="filteredWaiters"
      class="flex-full-table"
      @rowClick="r => showEditUI(r._id)"
    >
      <template v-slot:col-bot="slotProps">
        {{
          slotProps.rowItem.personal_telegram_id
            ? $t("workers_table.bot_connected")
            : $t("workers_table.bot_not_connected")
        }}
      </template>

      <template #actions="slotProps">
        <BaseButton @click="showEditUI(slotProps.rowItem._id)" variant="secondary" icon="pencil" size="sm" color="v1-grey-3"/>
        <BaseButton @click="showRemoveUI(slotProps.rowItem._id)" variant="secondary" icon="trash" size="sm" color="v1-grey-3" class="ml-8"/>
      </template>
    </IQOSTable>

    <!-- <table class="qrw-simple-table workers-table">
      <thead>
        <th class="sm">{{ $t("workers_table.col_no") }}</th>
        <th>{{ $t("workers_table.col_name") }}</th>
        <th>{{ $t("workers_table.col_pin") }}</th>
        <th>QRWaiter Bot</th>
        <th></th>
      </thead>
      <tbody>
        <tr v-for="(waiter, index) in filteredWaiters" :key="waiter._id">
          <td @click="showEditUI(waiter._id)" class="sm">{{ index + 1 }}</td>
          <td @click="showEditUI(waiter._id)">{{ waiter.name }}</td>
          <td @click="showEditUI(waiter._id)">{{ waiter.pin }}</td>
          <td @click="showEditUI(waiter._id)">
            {{
              !!waiter.personal_telegram_id
                ? $t("workers_table.bot_connected")
                : $t("workers_table.bot_not_connected")
            }}
          </td>
          <td>
            <div class="delete-button" @click="showRemoveUI(waiter._id)">
              <div class="image"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table> -->

    <DangerConfirmModal
      @cancel="remove_id = null"
      @confirm="removeWaiter"
      v-if="remove_id"
    >
      {{ $t("workers_table.confirm_delete") }}
    </DangerConfirmModal>
  </div>
</template>

<script>
import WaitersAPI from "@/api/waiters";

import BlackInput from "@/components/BlackInput.vue";

import DashboardButton from "@/components/DashboardButton.vue";

export default {
  data() {
    return {
      waiters: [],
      remove_id: null,
      search_focused: false,
      search: null,
    };
  },
  methods: {
    fetchWaiters() {
      WaitersAPI.getCafeWaiters(this.cafe._id)
        .then((data) => {
          this.waiters = data.waiters;
          this.$store.commit("setWaiters", this.waiters);
        })
        .catch((error) => {
          alert(error);
        });
    },
    createWaiter() {
      WaitersAPI.createWaiter(this.cafe._id)
        .then((data) => {
          this.$store.dispatch("auditlog/write", {
            type: "add_waiter",
            payload: {
              id: data.waiter._id,
              cafe_id: this.cafe._id,
            },
          });

          this.$router.push({
            name: "worker_profile",
            params: {
              id: data.waiter._id,
            },
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    showEditUI(id) {
      this.$router.push({
        name: "worker_profile",
        params: {
          id,
        },
      });
    },
    showRemoveUI(id) {
      this.remove_id = id;
    },
    removeWaiter() {
      WaitersAPI.removeWaiter(this.remove_id)
        .then((data) => {
          this.fetchWaiters();

          this.$store.dispatch("auditlog/write", {
            type: "remove_waiter",
            payload: {
              id: this.remove_id,
            },
          });
          this.remove_id = null;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    this.fetchWaiters();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    filteredWaiters() {
      if (!this.search) return this.waiters;

      const q = this.search.toLowerCase();

      return this.waiters.filter((w) => w.name && w.name.toLowerCase().includes(q));
    },
    currentPosSystem() {
      return this.$store.getters.currentPosSystem;
    }
  },
  components: {
    DashboardButton,
    BlackInput,
  },
};
</script>

<style scoped>

</style>
